// 配置管理 - localStorage读写

export interface AppConfig {
  baseURL: string;
  desktopPeerId: string;
  pageTitle: string;
  printerIP: string;
  logoURL: string;
  appendText: string;
}

const CONFIG_KEY = 'lensflow_config';

export function getConfig(): AppConfig {
  const defaultConfig: AppConfig = {
    baseURL: '',
    desktopPeerId: '',
    pageTitle: '顾客信息填写',
    printerIP: '',
    logoURL: '',
    appendText: '',
  };

  const stored = localStorage.getItem(CONFIG_KEY);
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      // 确保包含所有必需的字段（兼容旧配置）
      return {
        ...defaultConfig,
        ...parsed,
        desktopPeerId: parsed.desktopPeerId ?? '',
        appendText: parsed.appendText ?? '',
      };
    } catch {
      // 如果解析失败，返回默认值
    }
  }
  return defaultConfig;
}

export function saveConfig(config: AppConfig): void {
  localStorage.setItem(CONFIG_KEY, JSON.stringify(config));
}

/**
 * 测试服务器连接性
 */
export async function pingEndpoint(baseURL: string): Promise<boolean> {
  if (!baseURL) {
    return false;
  }
  
  try {
    const response = await fetch(`${baseURL}/ping`, {
      method: 'GET',
      signal: AbortSignal.timeout(3000), // 3 second timeout
    });
    return response.ok;
  } catch {
    return false;
  }
}

